import SinglePredictionsBreakdown from "./SinglePredictionsBreakdown";

export default class SummarizedBreakdown {
    public footballCompetitions: SinglePredictionsBreakdown[] = [];
    public footballTeams: SinglePredictionsBreakdown[] = [];
}